<h2 class="cart-submission-confirmation-dialog__title fo-dialog-content" mat-dialog-title>
  {{ 'employee.basket.cart-submission-confirmation-popup.title' | translate }}
</h2>

<mat-dialog-content>
  <div class="cart-submission-confirmation-dialog__body">
    <p class="cart-submission-confirmation-dialog__intro">
      {{ 'employee.basket.cart-submission-confirmation-popup.intro' | translate }}
    </p>

    <p class="cart-submission-confirmation-dialog__warning">
      <span class="cart-submission-confirmation-dialog__warning-text">
        <span class="cart-submission-confirmation-dialog__warning-label">
          <mat-icon
            class="cart-submission-confirmation-dialog__warning-icon"
            svgIcon="fo-warn"
          ></mat-icon>
          <span>{{
            'employee.basket.cart-submission-confirmation-popup.warning-label' | translate
          }}</span>
        </span>
        {{ 'employee.basket.cart-submission-confirmation-popup.warning' | translate }}
      </span>
    </p>

    <p class="cart-submission-confirmation-dialog__closing">
      {{ 'employee.basket.cart-submission-confirmation-popup.closing' | translate }}
    </p>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="fo-dialog-actions fo-dialog-actions_small">
    <button
      cdkFocusInitial
      class="fo-color-secondary"
      matButton="filled"
      type="button"
      (click)="confirm()"
    >
      {{ 'general.conf' | translate }}
    </button>
    <button class="fo-color-error" matButton="filled" type="button" (click)="cancel()">
      {{ 'general.cancel' | translate }}
    </button>
  </div>
</mat-dialog-actions>
